import React from "react";
import { useFormikContext, Field } from "formik";
import { Grid, TextField, RadioGroup, FormControlLabel, Radio } from "@material-ui/core";
import SectionCard from "./SectionCard";

const SubAgentInformation: React.FC = () => {
  const { values, handleChange } = useFormikContext<any>();

  return (
    <SectionCard title="New Sub Agent" >
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField fullWidth name="fullName" label="Agency Name *" value={values.fullName || ""} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField fullWidth name="phoneNumber" label="Phone number" value={values.phoneNumber || ""} onChange={handleChange} />
        </Grid>

        {/* <Grid item xs={12} md={6}>
          <TextField fullWidth name="contactEmail" label="Contact E-mail *" value={values.contactEmail || ""} onChange={handleChange} />
        </Grid> */}
         <Grid item xs={12} md={6}>
          <TextField fullWidth name="email" label="E-mail *" value={values.email || ""} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField fullWidth name="companyName" label="Company Name" value={values.companyName || ""} onChange={handleChange} />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField fullWidth name="location" label="Location" value={values.location || ""} onChange={handleChange} />
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth name="address" label="Address" multiline  value={values.address || ""} onChange={handleChange} />
        </Grid>

        {/* Invoice logo choice */}
        <Grid item xs={12}>
          <div style={{ marginBottom: 8 }}>Invoice logo:</div>
          <RadioGroup row name="isOperatorLogo" value={values.isOperatorLogo ?? true} onChange={(e) => (values.isOperatorLogo = e.target.value === "true")}>
            <FormControlLabel value={true} control={<Radio />} label="Use the operator logo" />
            <FormControlLabel value={false} control={<Radio />} label="Use the agency logo" />
          </RadioGroup>
        </Grid>

        <Grid item xs={12}>
          <TextField fullWidth name="invoiceText" label="Text on the invoice" value={values.invoiceText } onChange={handleChange} />
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth name="invoiceBottomText" label="Text below the invoice" value={values.invoiceBottomText } onChange={handleChange} />
        </Grid>
      </Grid>
    </SectionCard>
  );
};

export default SubAgentInformation;
